import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import FormField from "../components/FormField";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { cerberus, errorMessage } from "../api/cerberus";
import { completeLogin } from "../lib/session";

interface ChallengeState {
  challenge_token: string;
  user_id: string;
  email: string;
  return_to: string | null;
}

function isChallengeState(v: unknown): v is ChallengeState {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return typeof r.challenge_token === "string" && typeof r.user_id === "string";
}

export default function MfaChallenge(): JSX.Element {
  const loc = useLocation();
  const state = isChallengeState(loc.state) ? loc.state : null;
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!state) {
    return <Navigate to="/login" replace />;
  }

  async function onSubmit(ev: FormEvent): Promise<void> {
    ev.preventDefault();
    if (!state) return;
    setError(null);
    setBusy(true);
    try {
      const tp = await cerberus.mfaChallenge({
        challenge_token: state.challenge_token,
        user_id: state.user_id,
        code: code.trim(),
      });
      completeLogin(tp, state.return_to);
    } catch (e) {
      setError(errorMessage(e, "mfa challenge failed"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Codigo MFA"
      subtitle={`Insira o codigo de 6 digitos do seu app autenticador (${state.email}).`}
    >
      {error ? <Alert variant="error">{error}</Alert> : null}
      <form onSubmit={onSubmit} noValidate>
        <FormField
          label="Codigo TOTP ou backup"
          name="code"
          inputMode="text"
          autoComplete="one-time-code"
          autoFocus
          required
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? "Verificando..." : "Verificar"}
        </Button>
      </form>
    </AuthLayout>
  );
}
